import { DocumentTabSettings, StoreNameEnum } from "../../../../../libs/ui-settings-manager/interfaces";

export const invoiceItemCreatorTabOrder: DocumentTabSettings = {
    enabledFields: [
        'idGoodsGlobal',
        'idScalingRatioGlobal',
        'countDocs',
        'damageQuantity',
        'defectQuantity',
        'shortageQuantity',
        'inputKiz',
        'manufacturerPrice',
        'manufacturerMarginalPrice',
        'vatRateWholesale',
        'suppliersPrice',
        'supplierAmount',
        'supplierVatAmount',
        'supplierPriceWithVat',
        'amountOfThePaymentWithVat',
        'retailPrice',
        'retailVatRate',
        'percentageOfMarkupRetailChanged',
        'retailAmountWithoutVat',
        'retailAmountWithVatSum',
        'sellingPrice',
        'retailAmountWithVat',
        'priceContract',
        'cancelButton',
        'okButton'
    ],
    tabOrder: [
        'idGoodsGlobal',
        'idScalingRatioGlobal',
        'countDocs',
        'damageQuantity',
        'defectQuantity',
        'shortageQuantity',
        'inputKiz',
        'manufacturerPrice',
        'manufacturerMarginalPrice',
        'vatRateWholesale',
        'suppliersPrice',
        'supplierAmount',
        'supplierVatAmount',
        'supplierPriceWithVat',
        'amountOfThePaymentWithVat',
        'retailVatRate',
        'percentageOfMarkupRetailChanged',
        'retailPrice',
        'retailAmountWithoutVat',
        'retailAmountWithVatSum',
        'sellingPrice',
        'retailAmountWithVat',
        'priceContract',
        'cancelButton',
        'okButton'
    ],
    autoSkipDisabled: true,
    documentSettings: {
        booleanSettings: [
            {
                name: "useLotWinnerAsInvoiceSupplier",
                label: "documents.invoice.documentUISettings.useLotWinnerAsInvoiceSupplier",
                state: false
            },
			{
                name: "allowFillByGosContract",
                label: "documents.invoice.documentUISettings.allowFillByGosContract",
                state: false
            },
            {
                name: "disabledFieldForGC",
                label: "documents.invoice.documentUISettings.blockFieldForGC",
                state: true
            },
            {
                name: "showLastSearchQuery",
                label: "documents.invoice.documentUISettings.showLastSearchQuery",
                state: true
            },
            {
                name: "coloredRowIsGnvls",
                label: "documents.invoice.documentUISettings.coloredRowIsGnvls",
                state: true
            }
        ]
    },
    documentStore: [
        {
            name: StoreNameEnum.lastSearchQuery,
            fieldName: 'inputAccompanyingSelectionGoods',
            value: []
        }
    ]
}
